import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeamsService {

  constructor(private http: HttpClient, private router: Router) { }
  getAllRolessearch(roleName:any ,page:any, size:any) {
    return this.http.get<any>(`${environment.baseurl}/masterData/getAllRoles?roleName=${roleName}&pageNo=${page}&pageSize=${size}`);
  }
  getAllRoles(page:any, size:any) {
    return this.http.get<any>(`${environment.baseurl}/masterData/getAllRoles?pageNo=${page}&pageSize=${size}`);
  }
  // searchTeam(name,code,roleId,no,size){
  //   return this.http.get<any>(`${environment.baseurl}/v1/TtvnMasterData/TeamSearchByNameAndCode?name=${name}&code=${code}&roleId=${roleId}&page=${no}&size=${size}`)
  // }

  getRoleById(roleId:any) {
    return this.http.get<any>(`${environment.baseurl}/masterData/getRoleById?roleId=` + roleId);
  }

  updateroleStatus(id:any,data:any){
    return this.http.post<any>(`${environment.baseurl}/masterData/UpdateStatusRole?roleId=${id}`, data);
  }


  saveOrUpdateRole(data:any) {
    return this.http.post<any>(`${environment.baseurl}/masterData/saveOrUpdateRole`, data);
  }

  deleteRole(id:any) {
    return this.http.delete<any>(`${environment.baseurl}/masterData/deleteRoleById?roleId=` + id);
  }

  //Team
  getAllTeam(page:any, size:any,name:any) {
    return this.http.get<any>(`${environment.baseurl}/masterData/TeamSearchByNameAndCode?pageNo=` + page + `&pageSize=` + size+`&name=`+name);
  }

  getTeamById(roleId:any) {
    return this.http.get<any>(`${environment.baseurl}/masterData/getTeamById?teamId=` + roleId);
  }
  getAllModule(page:any, size:any) {
    return this.http.get<any>(`${environment.baseurl}/masterData/getAllModules?pageNo=` + page + `&pageSize=` + size	);
  }

  saveOrUpdateTeam(data:any) {
    return this.http.post<any>(`${environment.baseurl}/masterData/saveOrUpdateTeam`, data);
  }

  deleteTeam(id:any) {
    return this.http.delete<any>(`${environment.baseurl}/masterData/deleteTeamById?teamId=` + id);
  }

  updateTeamStatus(id:any,data:any){
    return this.http.post<any>(`${environment.baseurl}/v1/TtvnMasterData/UpdateStatusTeam?teamId=${id}`, data);
  }
  getmoduleById(moduleId:any) {
    return this.http.get<any>(`${environment.baseurl}/masterData/getModuleDetailsById?moduleId=` + moduleId);
  }
  saveOrUpdatemodule(data:any) {
    return this.http.post<any>(`${environment.baseurl}/masterData/saveAndUpdateModuleDetails`, data);
  }
  // saveOrUpdateprivilge(data) {
  //   return this.http.post<any>(`${environment.baseurl}/v1/TtvnMasterData/saveOrUpdateTeam`, data);
  // }
  saveAndUpdateRolePrivilege(data:any) {
    return this.http.post<any>(`${environment.baseurl}/masterData/saveAndUpdateRolePrivilege`,data);
  }
  // getAllprivilege(){
  //   return this.http.get<any>(`${environment.baseurl}/v1/TtvnMasterData/getAllPrivilege`);
  // }

  getPrivilegesByRoleId(roleID:any){
    return this.http.get<any>(`${environment.baseurl}/masterData/getPrivilegesByRoleId?roleId=${roleID}`);
  }

  // getAllModules(isActive){
  //   return this.http.get<any>(`${environment.baseurl}/v1/TtvnMasterData/getAllModules?isActive= ${isActive}`);
  // }
}
